import type { StyleLayer } from './utils/types'

export const layers_parkingLars_parkinglines_surface: StyleLayer[] = [
  {
    id: 'street parking lines copy 1',
    type: 'line',
    filter: ['has', 'capacity'],
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'surface'], ['ground', 'grass_paver', 'compacted'], true, false],
        'hsl(142, 94%, 40%)',
        ['match', ['get', 'surface'], ['concrete', 'concrete:plates', 'asphalt'], true, false],
        'hsl(344, 93%, 35%)',
        ['match', ['get', 'surface'], ['cobblestone', 'sett', 'paving_stones'], true, false],
        'hsl(164, 92%, 42%)',
        ['has', 'surface'],
        'hsl(280, 94%, 63%)',
        'hsl(280, 67%, 26%)',
      ],
      'line-opacity': ['match', ['get', 'operator_type'], ['private'], 0.33, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
  },
  {
    id: 'parallel pattern copy',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['parallel'], true, false],
      ['has', 'capacity'],
    ],
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-dasharray': [4, 2],
      'line-opacity': 0.67,
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 0.7, 20, 5],
    },
  },
  {
    id: 'diagonal pattern copy',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['diagonal'], true, false],
      ['has', 'capacity'],
    ],
    minzoom: 16,
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-opacity': 0.67,
      'line-pattern': 'pattern-parking-diagonal',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
  },
  {
    id: 'perpendicular pattern copy',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['perpendicular'], true, false],
      ['has', 'capacity'],
    ],
    minzoom: 16,
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-opacity': 0.67,
      'line-pattern': 'pattern-parking-perpendicular',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
  },
  {
    id: 'surface label-line',
    type: 'symbol',
    filter: ['has', 'capacity'],
    minzoom: 15,
    layout: {
      'symbol-placement': 'line-center',
      'text-allow-overlap': true,
      'text-field': ['to-string', ['get', 'surface']],
      'text-ignore-placement': true,
      'text-offset': [0, 0.8],
      'text-size': ['interpolate', ['linear'], ['zoom'], 15, 9, 18, 16],
    },
    paint: {
      'text-color': 'rgb(60, 60, 60)',
      'text-halo-color': 'rgb(255, 255, 255)',
      'text-halo-width': ['interpolate', ['linear'], ['zoom'], 15, 1, 18, 2.5],
      'text-opacity': ['interpolate', ['linear'], ['zoom'], 17, 0, 18, 1],
    },
  },
]
